/* eslint-disable-next-line unicode-bom */
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { FaCar, FaEdit, FaSitemap } from 'react-icons/fa';
import { HiOutlineRectangleGroup } from 'react-icons/hi2';
import { useDispatch } from 'react-redux';
import { vehicleGroupService } from '../../Services/vehicle.group.service';
import { vehicleService } from '../../Services/vehicle.service';
import { maintenancesService } from '../../Services/maintenances.service';
import { odometersService } from '../../Services/odometers.service';
import { useSelected } from '../../contexts/SelectedContext';
import { Filters } from '../../components/Filters';
import { GridComponent, ColumnsDirective, ColumnDirective, Inject, Page } from '@syncfusion/ej2-react-grids';
import { Modal, Button } from 'react-bootstrap';
import SyncFusionDateTimePicker from '../Components/SyncFusionDateTimePicker/SyncFusionDateTimePicker';
import { ToastComponent } from '../Components/ToastComponent';
import { paginationService } from '../../Services/pagination.service';
import EmptyData from '../../components/EmptyData';
import { toLocalDateTimeString } from '../../Services/string.service';


export const ShippingItems = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch(); /** eslint-disable-next-line */
    dispatch({ type: "title", value: t("MAINTENANCES.SHIPPING.TITLE") });

    const { selectedValues } = useSelected();
    const selectedGroup = selectedValues.veiculos?.[0] || 0;
    const selectedVehicle = selectedValues.veiculosGroups?.[0] || 0;

    const [vehicleGroups, setVehicleGroups] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [items, setItems] = useState([]);
    const [, setFiltersLoading] = useState(false);
    const [isLoadingVehicles, setIsLoadingVehicles] = useState(false);
    const [itens, setItens] = useState([]);
    const [isLoadingItens, setIsLoadingItens] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editItem, setEditItem] = useState(null);
    const [modalDate, setModalDate] = useState(null);
    const [modalCost, setModalCost] = useState('');
    const [modalOdometer, setModalOdometer] = useState('');
    const [isSaving, setIsSaving] = useState(false);
    const [toastParams, setToastParams] = useState(JSON.stringify({ show: false }));
    const [pageSize, setPageSize] = useState(15);

    const gridAnchorRef = useRef(null);
    const ROW_HEIGHT = 40;
    const HEADER_PAGER_BUDGET = 100;
    const BOTTOM_MARGIN = 30;
    const MIN_PAGE = 5;
    const MAX_PAGE = 100;

    const fetchVehicleGroups = async () => {
        try {
            setFiltersLoading(true);
            const groups = await vehicleGroupService.fetchGroups();

            if (Array.isArray(groups)) {
                setVehicleGroups(groups);
                if (groups.length === 1) {
                    await fetchVehiclesByGroup(groups[0].vehicleGroupId);
                } else {
                    await fetchVehiclesByGroup(0);
                }
            } else {
                setVehicleGroups([]);
                if (groups?.error) {
                    console.log("Erro ao buscar grupos:", groups.message || groups.friendlyMessage);
                }
                await fetchVehiclesByGroup(0);
            }
        } catch (error) {
            console.log(error);
            setVehicleGroups([]);
        } finally {
            setFiltersLoading(false);
        }
    };

    const fetchVehiclesByGroup = async (groupId) => {
        setIsLoadingVehicles(true);
        try {
            const vehicles = await vehicleService.fetchVehicles(groupId);
            if (Array.isArray(vehicles)) {
                setVehicles(vehicles);
            } else {
                setVehicles([]);
                if (vehicles?.error) {
                    console.log("Erro ao buscar veículos:", vehicles.message || vehicles.friendlyMessage);
                }
            }
        } catch (error) {
            console.log(error);
            setVehicles([]);
        } finally {
            setIsLoadingVehicles(false);
        }
    };

    const listItens = async () => {
        setIsLoadingVehicles(true);
        try {
            const itens = await maintenancesService.fetchItemsMaintenace();
            if (Array.isArray(itens)) {
                setItems([{ maintenanceItemId: 0, maintenanceItemName: "Todos" }, ...itens]);
            } else {
                setItems([{ maintenanceItemId: 0, maintenanceItemName: "Todos" }]);
            }
        } catch (error) {
            console.log(error);
            setItems([]);
        } finally {
            setIsLoadingVehicles(false);
        }
    };

    const fetchSummary = async () => {
        setIsLoadingItens(true);
        try {
            const vehicleId = selectedVehicle && selectedVehicle !== "TODOS" && selectedVehicle !== 0 ? selectedVehicle : 0;
            const response = await maintenancesService.fetchItemsScheduling(vehicleId, true);
            setItens(Array.isArray(response) ? response : []);
        } catch (error) {
            console.log(error);
            setItens([]);
        } finally {
            setIsLoadingItens(false);
        }
    };

    useEffect(() => {
        if (selectedGroup !== null && selectedGroup !== undefined) {
            fetchVehiclesByGroup(selectedGroup);
        }
    }, [selectedGroup]);

    useEffect(() => {
        fetchVehicleGroups();
        listItens();
        fetchSummary();
  // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isLoadingItens && itens.length > 0) {
            paginationService.calculateGridMetrics(
                gridAnchorRef, BOTTOM_MARGIN, HEADER_PAGER_BUDGET,
                ROW_HEIGHT, MIN_PAGE, MAX_PAGE, itens, window.innerHeight, setPageSize
            );
        }

        let t = null;
        const onResize = () => {
            if (t) window.clearTimeout(t);
            t = window.setTimeout(() => paginationService.calculateGridMetrics(
                gridAnchorRef, BOTTOM_MARGIN, HEADER_PAGER_BUDGET,
                ROW_HEIGHT, MIN_PAGE, MAX_PAGE, itens, window.innerHeight, setPageSize
            ), 50);
        };

        window.addEventListener("resize", onResize);
        return () => {
            window.removeEventListener("resize", onResize);
            if (t) window.clearTimeout(t);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadingItens, itens]);

    const formatKm = (value) => {
        const numericValue = value.replace(/\D/g, '');
        return numericValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    };

    const handleOdometerChange = (e) => {
        const rawValue = e.target.value;
        const formattedValue = formatKm(rawValue);
        setModalOdometer(formattedValue);
    };

    const handleEdit = (props) => {
        setEditItem(props);
        setModalDate(null);
        setModalCost('');
        setModalOdometer('');
        setShowEditModal(true);
    };

    // Registra o odômetro informado na tela, usando o veículo selecionado e a data do modal.
    // Retorna false se a chamada falhou (pra quem chamou poder interromper o fluxo).
    const registerOdometerFromModal = async (dateValue) => {
        if (!modalOdometer) return true;

        const normalizedOdometer = Number(modalOdometer.replace(/\./g, ''));
        if (!normalizedOdometer) return true;

        try {
            await odometersService.createOdometer({
                VehicleId: Number(selectedVehicle),
                VehicleOdometerId: 0,
                OdometerDateTime: toLocalDateTimeString(new Date(dateValue)),
                OdometerValue: normalizedOdometer,
            });
            return true;
        } catch (odometerError) {
            console.error('Erro ao registrar hodômetro:', odometerError);
            const msg = odometerError?.response?.data?.message || "Não foi possível registrar o hodômetro.";
            setToastParams(JSON.stringify({ show: true, title: "Erro", body: msg, color: "danger" }));
            return false;
        }
    };

    const handleConcluir = async () => {
        if (!modalDate) {
            setToastParams(JSON.stringify({ show: true, title: "Atenção", body: "Informe a data de execução.", color: "warning" }));
            return;
        }
        setIsSaving(true);
        try {
            const odometerOk = await registerOdometerFromModal(modalDate);
            if (!odometerOk) return;

            const payload = {
                maintenanceScheduleId: editItem.maintenanceId ?? editItem.maintenanceScheduleId ?? editItem.schedulingId ?? 0,
                vehicleId: selectedVehicle,
                maintenanceItemId: String(editItem.maintenanceItemId ?? editItem.MaintenanceItemId),
                maintenanceBase: "DI",
                mileage: editItem.finalOdometer ?? editItem.kmInterval ?? 0,
                days: 0,
                hours: 0,
                active: "S",
                cost: modalCost ? parseFloat(modalCost.replace(/[^\d,]/g, '').replace(',', '.')) : 0,
                maintenanceStatus: 4,
                startDate: editItem.startDate ?? null,
                executionDate: toLocalDateTimeString(new Date(modalDate)),
            };
            const success = await maintenancesService.createNewScheduling(payload);
            if (success) {
                setToastParams(JSON.stringify({ show: true, title: "Sucesso", body: "Manutenção concluída com sucesso!", color: "success" }));
                setShowEditModal(false);
                fetchSummary();
            } else {
                setToastParams(JSON.stringify({ show: true, title: "Erro", body: success?.message || "Erro ao concluir. Tente novamente.", color: "danger" }));
            }
        } catch (error) {
            setToastParams(JSON.stringify({ show: true, title: "Erro", body: error?.response?.data?.message || "Erro ao concluir.", color: "danger" }));
        } finally {
            setIsSaving(false);
        }
    };

    const handleReagendar = async () => {
        if (!modalDate) {
            setToastParams(JSON.stringify({ show: true, title: "Atenção", body: "Informe a data.", color: "warning" }));
            return;
        }
        setIsSaving(true);
        try {
            const odometerOk = await registerOdometerFromModal(modalDate);
            if (!odometerOk) return;

            const payload = {
                maintenanceScheduleId: editItem.maintenanceId ?? editItem.maintenanceScheduleId ?? editItem.schedulingId ?? 0,
                vehicleId: selectedVehicle,
                maintenanceItemId: String(editItem.maintenanceItemId ?? editItem.MaintenanceItemId),
                maintenanceBase: "KM",
                mileage: editItem.finalOdometer ?? editItem.kmInterval ?? 0,
                days: editItem.days ?? editItem.daysInterval ?? 0,
                hours: 0,
                active: "S",
                cost: editItem.cost ?? 0,
                maintenanceStatus: new Date(modalDate) > new Date() ? 1 : 3,
                startDate: toLocalDateTimeString(new Date(modalDate)),
                executionDate: null,
            };
            const success = await maintenancesService.createNewScheduling(payload);
            if (success) {
                setToastParams(JSON.stringify({ show: true, title: "Sucesso", body: "Reagendado com sucesso!", color: "success" }));
                setShowEditModal(false);
                fetchSummary();
            } else {
                setToastParams(JSON.stringify({ show: true, title: "Erro", body: success?.message || "Erro ao reagendar. Tente novamente.", color: "danger" }));
                fetchSummary();
            }
        } catch (error) {
            setToastParams(JSON.stringify({ show: true, title: "Erro", body: error?.response?.data?.message || "Erro ao reagendar.", color: "danger" }));
        } finally {
            setIsSaving(false);
        }
    };

    const handleDelete = () => {
        setItens(itens.filter(item => item.id !== deleteId));
        setShowModal(false);
        setDeleteId(null);
    };

    const actionTemplateEdit = (props) => {
        const isConcluido = props.maintenanceStatus === 4;
        return isConcluido ? (
            <button
                className="btn btn-link p-0"
                style={{ color: "var(--text-primary)" }}
                onClick={() => handleEdit(props)}
            >
                <FaEdit size={18} />
            </button>
        ) : (
            <button
                className="btn btn-primary btn-sm"
                onClick={() => handleEdit(props)}
            >
                Concluir
            </button>
        );
    };

    return (
        <div className="container-xxl flex-grow-1 container-p-y">
            <p>{t("MAINTENANCES.SHIPPING.DESCRIPTION")}</p>
            <div className="filter-maintenance">
                <Filters
                    id={"veiculos"}
                    isMulti={false}
                    title={t("VIEW_MAP_FILTERS.GROUPS")}
                    hasSubTitle={true}
                    subTitle={t("VIEW_MAP_FILTERS.ALL_GROUPS")}
                    options={vehicleGroups || []}
                    icon={HiOutlineRectangleGroup}
                    hasIcon={true}
                    pageTitle={"maintenances_shipping"}
                    onChange={(groupId) => fetchVehiclesByGroup(groupId === "TODOS" ? 0 : groupId)}
                />
                <Filters
                    id={"veiculosGroups"}
                    isMulti={false}
                    title={t("VIEW_MAP_FILTERS.VEHICLES")}
                    hasSubTitle={true}
                    subTitle={t("VIEW_MAP_FILTERS.ALL_VEHICLES")}
                    options={vehicles || []}
                    icon={FaCar}
                    hasIcon={true}
                    pageTitle={"maintenances_shipping"}
                    isLoading={isLoadingVehicles}
                />
                <Filters
                    id={"itens"}
                    isMulti={false}
                    title={t("MAINTENANCES.SHIPPING.ITEMS")}
                    hasSubTitle={true}
                    subTitle={t("MAINTENANCES.SHIPPING.SELECT_ITEM")}
                    options={items || []}
                    icon={FaSitemap}
                    hasIcon={true}
                    pageTitle={"maintenances_shipping"}
                    isLoading={isLoadingVehicles}
                />
                <button className='btn btn-primary' onClick={fetchSummary} disabled={isLoadingItens}>
                    {t("MAINTENANCES.SHIPPING.SEARCH")}
                </button>
            </div>

            <div className="scheduling-section">
                <h3 className='h3-light'>{t("MAINTENANCES.SHIPPING.VEHICLE_ITEMS")}</h3>

                <div className="container-maintenances">
                    <div className="card">
                        <div ref={gridAnchorRef} />
                        <GridComponent
                            dataSource={itens}
                            allowPaging={true}
                            pageSettings={{ pageSize }}
                            rowHeight={ROW_HEIGHT}
                            height={"auto"}
                            emptyRecordTemplate={() => <EmptyData />}
                            actionComplete={() => {
                                setTimeout(() => paginationService.calculateGridMetrics(
                                    gridAnchorRef, BOTTOM_MARGIN, HEADER_PAGER_BUDGET,
                                    ROW_HEIGHT, MIN_PAGE, MAX_PAGE, itens, window.innerHeight, setPageSize
                                ), 50);
                            }}
                        >
                            <ColumnsDirective>
                                <ColumnDirective field="plate" headerText={t("MAINTENANCES.SHIPPING.VEHICLE")} width="120" />
                                <ColumnDirective field="maintenanceItemDescription" headerText={t("MAINTENANCES.SHIPPING.ITEM")} width="150" />
                                <ColumnDirective field="startDate" headerText="Inicio" width="120"
                                    template={(props) => {
                                        const d = new Date(props.startDate);
                                        if (!props.startDate || d.getFullYear() <= 1) return null;
                                        return <span>{d.toLocaleDateString('pt-BR')}</span>;
                                    }}
                                />
                                <ColumnDirective field="kmInterval" headerText="KM" width="100" textAlign="Right" />
                                <ColumnDirective field="daysInterval" headerText="Dias" width="100" textAlign="Right" />
                                <ColumnDirective field="maintenanceStatus" headerText={t("MAINTENANCES.SHIPPING.STATUS")} width="100" textAlign="Center" />
                                <ColumnDirective
                                    headerText={t("MAINTENANCES.SHIPPING.EDIT")}
                                    width="80"
                                    textAlign="Center"
                                    template={actionTemplateEdit}
                                />
                            </ColumnsDirective>
                            <Inject services={[Page]} />
                        </GridComponent>
                    </div>
                </div>
            </div>

            <ToastComponent params={toastParams} closeToast={() => setToastParams(JSON.stringify({ show: false }))} />

            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Manutenção</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editItem && (
                        <div className="row g-3">
                            <div className="col-12">
                                <label className="form-label">Placa</label>
                                <input className="form-control" value={editItem.plate ?? ''} disabled />
                            </div>
                            <div className="col-12">
                                <label className="form-label">Item</label>
                                <input className="form-control" value={editItem.maintenanceItemDescription ?? editItem.maintenanceItem ?? ''} disabled />
                            </div>
                            <div className="col-12">
                                <label className="form-label">Data *</label>
                                <SyncFusionDateTimePicker
                                    id="modalDate"
                                    value={modalDate}
                                    onChange={setModalDate}
                                    placeholder="Data"
                                    step={30}
                                />
                            </div>
                            <div className="col-12">
                                <label className="form-label">Hodômetro</label>
                                <input
                                    className="form-control"
                                    value={modalOdometer}
                                    onChange={handleOdometerChange}
                                    placeholder="0"
                                />
                            </div>
                            <div className="col-12">
                                <label className="form-label">Custo (para encerrar)</label>
                                <input
                                    className="form-control"
                                    value={modalCost}
                                    onChange={(e) => setModalCost(e.target.value)}
                                    placeholder="R$ 0,00"
                                />
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)} disabled={isSaving}>
                        {t("MAINTENANCES.SHIPPING.CANCEL")}
                    </Button>
                    <Button variant="warning" onClick={handleReagendar} disabled={isSaving}>
                        {isSaving ? 'Salvando...' : 'Reagendar'}
                    </Button>
                    <Button variant="danger" onClick={handleConcluir} disabled={isSaving}>
                        {isSaving ? 'Salvando...' : 'Encerrar'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Body>{t("DELETE_MODAL.CONFIRM_DELETE")}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        {t("MAINTENANCES.SHIPPING.CANCEL")}
                    </Button>
                    <Button variant="danger" onClick={handleDelete}>
                        {t("MAINTENANCES.SHIPPING.DELETE")}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
